import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { APIS } from 'constants/api.constant'
import { postApi } from 'services/CommonService'

// ✅ Async upload function
export const uploadImage = createAsyncThunk(
    'upload/image',
    async (file, { rejectWithValue }) => {
        try {
            console.log("file in redux",file)
            const formData = new FormData()
          formData.append('file', file)

            const res = await postApi(APIS.UPLOAD,formData);
            console.log("image upload ", res)
            return res.location
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

const uploadSlice = createSlice({
    name: 'upload',
    initialState: {
        uploading: false,
        imageData: null,
        error: null,
    },
    reducers: {
        clearUpload: (state) => {
            state.data = null
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadImage.pending, (state) => {
                state.uploading = true
                state.error = null
            })
            .addCase(uploadImage.fulfilled, (state, action) => {
                state.uploading = false
                state.imageData = action.payload
            })
            .addCase(uploadImage.rejected, (state, action) => {
                state.uploading = false
                state.error = action.payload
            })
    },
})

export const { clearUpload } = uploadSlice.actions
export default uploadSlice.reducer